import { bemElement } from "utils/bem-class-names";
// @ts-ignore
import "./TermsAndConditions.scss";
import { SvgIcon } from "elements/svg-icon/svg-icon";
import TocPrivacyPolicyFooter from "components/toc-privacypolicy-footer/TocPrivacyPolicyFooter";

const baseClassName = "terms-and-conditions";
const bem = bemElement(baseClassName);

const TermsAndConditions = () => {
  return (
    <div className={baseClassName}>
      <div className={bem("title-container")}>
        <h3>Terms and Conditions</h3>
        <div className={bem("last-updated")}>
          Last updated: July 28, 2024{" "}
          <SvgIcon name="arrow_bottom" className={bem("arrow-icon")} />
        </div>
      </div>
      <section className={bem("contents")}>
        <article className={bem("content")}>
          <h5>Introduction</h5>
          <p>
            Welcome to www.pointmentapp.com (the “Website”). The Website and the
            mobile application (the “App”) are owned and operated by Pointment
            Inc., a Delaware corporation. (“Pointment,” “us,” “we,” or “our”).
            <br />
            <br />
            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THE
            WEBSITE OR THE MOBILE APP.
            <br />
            <br />
            By using the Website and/or the App, you (the “User, ” or “Guest”)
            signify your agreement to the terms and conditions set forth below
            (the “Terms and Conditions”) and to our privacy policy set forth
            here{" "}
            <a className={bem("link")} href="/privacypolicy">
              www.pointmentapp.com/privacypolicy
            </a>{" "}
            (the “Privacy Policy” and, together with the Terms and Conditions,
            the “Terms of Use”). Use of the Website, App, and any platform
            oﬀered herein is contingent upon compliance with the Terms &
            Conditions. In addition, when you use any of our current or future
            services, you will also be subject to our guidelines, terms,
            conditions, and agreements applicable to those services. If these
            Terms of Use are inconsistent with the guidelines, terms, and
            agreements applicable to those services, these Terms of Use will
            control. You agree that these Terms of Use are supported by
            reasonable and valuable consideration, the receipt and adequacy of
            which you hereby acknowledge, including, without limitation, your
            access to and use of the Website and App.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>1. License to Use Website and App</h5>
          <p>
            All content contained on the Website and App (collectively,
            “Content”), such as text, graphics, logos, icons, images, audio and
            video clips, digital downloads, and data compilations are our
            property or the property of our licensors or licensees, and the
            compilation of the Content on the Website and App is our exclusive
            property. Any trademarks, service marks, graphics, logos, page
            headers, icons, scripts, and trade names (each, a “Mark”) contained
            on the Website and App are proprietary to us or our licensors or
            licensees. Unless otherwise stated, Pointment and/or its licensors
            owns the intellectual property rights in the Website and App,
            including, but not limited to, the Content and the Marks. Subject to
            the license below, all of the aforementioned intellectual property
            rights are reserved.
            <br />
            <br />
            You may view, forward links, and print pages from the Website and
            App for your own personal use, subject to the restrictions set out
            below and elsewhere in these Terms of Use. You must not (a) sell,
            rent or sub-license material from the Website and App; (b)
            reproduce, duplicate, copy or otherwise exploit material on this
            Website and App for a commercial purpose; or (c) edit or otherwise
            modify any material on the Website and App.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>2. Acceptable & Prohibited Use</h5>
          <p>
            <b>(a) Acceptable Use. </b>{" "}
            <span>
              You may use the Website and App: (a) to inquire about services
              provided through Pointment; (b) purchase services and packages of
              services oﬀered through Pointment; (c) book appointments for
              services oﬀered at a business using the Pointment booking services
              (the “Pointment Platform”); AND (d) ﬁnd locations for a business
              that uses the Pointment Platform for appointment bookings
              (“Service Provider”).
            </span>
            <br />
            <br />
            <b>(b) Prohibited Use.</b> You must not: (a) use this Website and/or
            the App in any way that causes, or may cause, damage to the Website
            and/or App or impairment of the availability or accessibility of the
            Website and/or App; or in any way which is unlawful, illegal,
            fraudulent or harmful, or in connection with any unlawful, illegal,
            fraudulent or harmful purpose or activity; (b) you must not use this
            Website and/or App to copy, store, host, transmit, send, use,
            publish or distribute any material which consists of (or is linked
            to) any spyware, computer virus, Trojan horse, worm, keystroke
            logger, rootkit, or other malicious computer software; (c) you must
            not conduct any systematic or automated data collection activities
            (including without limitation scraping, data mining, data
            extraction, and data harvesting) on or in relation to this Website
            and/or the App without our express written consent; (d) you must not
            use this Website and/or the App to transmit or send unsolicited
            commercial communications; and (e) you must not use this Website
            and/or the App for any purposes related to marketing without our
            express written consent.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>3. User Content</h5>
          <p>
            In these Terms and Conditions, “your user content” means material
            (including without limitation text, images, audio material, video
            material, and audio-visual material) that you submit to this
            Website, the App, and Pointment’s social media channels for whatever
            purpose. You grant to Pointment a worldwide, irrevocable,
            non-exclusive, royalty-free license to use, reproduce, adapt,
            publish, translate, and distribute your user content in any existing
            or future media. You also grant to Pointment the right to
            sub-license these rights, and the right to bring an action for
            infringement of these rights. Your user content must not be illegal
            or unlawful, must not infringe any third party’s legal rights, and
            must not be capable of giving rise to legal action whether against
            you or Pointment or a third party (in each case under any applicable
            law). You must not submit any user content to the Website, the App
            or Pointment’s social media channels that is or has ever been the
            subject of any threatened or actual legal proceedings or other
            similar complaint. We reserve the right to edit or remove any
            material submitted, hosted, or published to this Website, the App,
            our social media channels, or material that is stored on our
            servers.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>4. Account Creation</h5>
          <p>
            <span>
              You may make an appointment for services by ﬁrst creating an
              account at www.pointmentapp.com or by downloading our App
              “Account”). To create an Account, you must provide the following
              information: (a) email address, and (b) password. This information
              is required for you to create an account. When registering for an
              Account, you must provide true, accurate, current, and complete
              data about yourself, including a phone number, on the Pointment
              registration form (“Registration Data”). You also agree to
              promptly update the Registration Data to keep it true, accurate,
              current, and complete. You are solely responsible for maintaining
              the confidentiality of your Account and the information in your
              Account, and, except as otherwise required by applicable law, you
              are solely responsible for all use of your Account, whether or not
              authorized by you. You agree to immediately notify Pointment of
              any unauthorized use of your Account or any other breach of
              security related to your use of the Services.
            </span>
          </p>
        </article>
        <article className={bem("content")}>
          <h5>5. SMS Communications</h5>
          <span>
            By providing your mobile phone number and opting in to receive text
            messages from Pointment, you consent to receive SMS communications
            related to your account and interactions with our services. These
            messages may include, but are not limited to:
          </span>

          <ul className="list-disc pl-5">
            <li>
              Appointment confirmations, reminders, updates, and cancellations
            </li>
            <li>Account-related notifications and service announcements</li>
            <li>
              Promotional messages, special offers, discounts, and marketing
              communications
            </li>
          </ul>

          <span>
            Message and data rates may apply. Message frequency may vary based
            on your account activity, appointments, and communication
            preferences. You may opt out of receiving SMS messages at any time
            by replying STOP to any text message. For assistance, reply HELP or
            contact our support team. Your consent to receive SMS messages is
            not a condition of any purchase. Wireless carriers are not liable
            for delayed or undelivered messages.
          </span>
          <p>
            <b>Customer SMS Communications.</b> By using Pointment’s SMS receipt
            functionality, the Salon agrees to obtain any consent required by
            applicable law before requesting that Pointment send SMS receipts to
            customers. The Salon is responsible for ensuring that customers have
            requested these messages and that the phone numbers provided are
            accurate. The Salon acknowledges that SMS receipt functionality must
            not be used for unsolicited marketing messages or communications
            outside the intended transactional purpose.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>6. Purchasing Services</h5>
          <p>
            <b>(a) Appointments.</b> You may make Pointment Service Appointments
            exclusively through the Pointment Website and App.
            <br />
            <br />
            <b>(b) Payment. </b>
            <span>
              When making an appointment, you will be asked to provide credit
              card billing information, which will be collected, processed, and
              stored by Stripe.
            </span>{" "}
            You are agreeing to the Terms and Conditions when you complete a
            purchase or booking on our site.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>7. Scheduling Service Appointments</h5>
          <p>
            <b>(a) Scheduling.</b> Pointment makes available service appointment
            services (“Service Appointments”) through the Pointment Site and
            App. In response to a User’s online request for a Service
            Appointment, the Pointment Site or App connects the User with a
            database of Service Providers with information about available
            Service Appointments. We do not guarantee the availability of a
            User’s first choice of appointment date, time, or a particular
            professional (“Service Professional”). By using the Pointment
            Platform to make Service Appointments, User agrees to receive
            appointment confirmations, updates, modifications and/or
            cancellations by email or other electronic messages.
            <br />
            <br />
            <b>(b) Cancellation.</b> If User needs to cancel an appointment,
            User should attempt to cancel by using the Pointment website or App.
            If User is not able to cancel the appointment through the Pointment
            website or App, User must contact the Service Provider directly to
            cancel the appointment. Please note that cancellation fee may apply.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>8. Appointment Experience</h5>
          <p>
            <b>(a) Arrival.</b> Please be sure to arrive to your appointment on
            time. Appointments shall be canceled if you arrive more than ten
            (10) minutes late. Guests arriving late to appointments may
            experience a shortened appointment duration.
            <br />
            <br />
            <b>(b) Right to Refuse Service.</b> Pursuant to California State
            Health and Safety Code Regulations Section 984, Nail Service
            Providers are prohibited from performing nail services on guests
            with infected skin or nails. For the protection of other Users and
            Service Providers, Service Providers using the Pointment Platform
            reserve the right to refuse services to guests based on the health
            of the guest’s nails, hands, or feet.
            <br />
            <br />
            <b>(c) Special Decorative Services.</b> Pointment Service Providers
            do not guarantee the results of special decorative services.
            Instead, Service Providers will provide Users with the best
            approximation of what they can achieve based on the User’s
            description of the decorative services requested or a photo of the
            requested services.
            <br />
            <br />
            <b>(d) Allergies & Medical Conditions.</b> Users should inform the
            Service Professional of any allergies or medical conditions that may
            impact Service. Service Providers reserve the right to refuse
            service to Guests who may be at risk of experiencing an adverse or
            dangerous reaction to a Service, or product oﬀered as part of a
            Service, due to an allergy or medical condition.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>9. Termination</h5>
          <p>
            <b>(a) Subscriptions.</b> You may terminate your Service
            Subscription by contacting{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>{" "}
            no later than twenty-four (24) hours prior to the next Renewal
            Billing Cycle.
            <br />
            <br />
            <b>(b) Accounts.</b> You may terminate your Pointment account at any
            time by contacting{" "}
            <a className={bem("link")} href="mailto:info@pointmentapp.com">
              info@pointmentapp.com
            </a>
            . Please be advised that refunds will not be provided for any
            purchased services that remain unused at the time of account
            cancellation.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>10. Warranties</h5>
          <p>
            <b>(a) As-Is Condition.</b> YOU ACCEPT THE SERVICES PROVIDED ON OUR
            WEBSITE, APP, AND IN A SERVICE PROVIDER’S LOCATION “AS IS,” WITH NO
            REPRESENTATION OR WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT OF INTELLECTUAL
            PROPERTY RIGHTS, OR ANY IMPLIED WARRANTY ARISING FROM STATUTE,
            COURSE OF DEALING, COURSE OF PERFORMANCE, OR USAGE OF
            <br />
            <br />
            <b>(b) Ownership Rights.</b> Pointment represents and warrants that
            it is the owner of the Website, App, and of each and every component
            thereof, or the recipient of a valid license thereto, and that it
            has and will maintain the full power and authority to grant the
            intellectual property rights to the Website and App set forth in
            this Agreement without the further consent of any third party.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>11. Intellectual Property</h5>
          <p>
            <b>(a) Protection of Intellectual Property.</b> The Website and App
            in their entirety, the domain name, the contents, and any
            information or material on them are protected under the relevant
            copyright, trademark, patent, and other intellectual property laws,
            unless otherwise speciﬁed herein. The content of the Website and App
            includes, but is not limited to, logos, trade names, word marks,
            design marks, trademarks, designs, text, images, graphics, pictures,
            information, videos, software, sound ﬁles, other ﬁles, and the
            arrangement thereof (“Intellectual Property”) all of which are the
            property of Pointment, or our licensors.
            <br />
            <br />
            <b>(b) Prohibited.</b> You shall not appropriate, copy, publicly
            display, reproduce, modify, republish, upload, post, transmit,
            scrape, collect, distribute, reverse engineer, or use the
            Intellectual Property from the Website or App for any other purpose
            other than the Acceptable Purpose as described in these Terms of
            Use. Any such unauthorized use may violate copyright, patent,
            trademark, and any other applicable laws and could result in
            criminal or civil penalties. In addition, the look and feel of our
            Website and App, including all page headers, custom graphics, button
            icons, and scripts, is the service mark, trademark and/or trade
            dress of Pointment and may not be copied, imitated, or used, in
            whole or in part, without prior written consent.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>12. Indemnifications</h5>
          <p>
            <b>(a) Indemniﬁcation by You.</b> You shall defend and indemnify
            Pointment and its directors, oﬃcers, employees, contractors, agents,
            assigns, and successors against any third party claim, suit, or
            proceeding arising out of or related to your alleged or actual use
            of, misuse of, or failure to use the Website or the App, and your
            failure to disclose any medical conditions or allergies resulting in
            injury arising out of a service provided by a Service Provider at a
            Service Provider’s location. Indemniﬁed Claims include, without
            limitation, claims arising out of or related to Pointment’s
            negligence. Indemnitor’s obligations in the preceding sentence and
            include retention and payment of attorneys and payment of court
            costs, as well as settlement at Indemnitor’s expense and payment of
            judgments.
            <br />
            <br />
            <b>(b) Mutual Indemniﬁcation.</b> Each party (“Indemnitor”) shall
            defend and indemnify the other party (“Indemniﬁed Party”) and its
            directors, oﬃcers, employees, contractors, agents, assigns, and
            successors, if applicable, against any third party claim, suit, or
            proceeding arising out of, related to, or alleging any of the
            following (any “Indemniﬁed Claim”): (i) unauthorized disclosure or
            exposure of personally identiﬁable information resulting from
            Indemnitor’s acts or omissions or from those of its contractors;
            (ii) injury to or death of any individual, or any loss of or damage
            to real or tangible personal property, resulting from Indemnitor’s
            acts or omissions or from those of its contractors; or (iii)
            intellectual property infringement by software or content Indemnitor
            contributed to the Website.
            <br />
            <br />
            <b>(c) Litigation.</b> Indemnitor’s obligations set forth in
            Subsections (a) and (b) above will be excused to the extent that the
            Indemniﬁed Party’s actions or the actions of any director, oﬃcer,
            employee, contractor, agent, assign, or successor of the Indemniﬁed
            Party, if applicable, materially prejudice the defense, due to
            failure to provide prompt notice of the Indemniﬁed Claim or failure
            to reasonably to cooperate. Indemnitor will control the defense of
            any Indemniﬁed Claim, including appeals, negotiations, and any
            settlement or compromise thereof; provided the Indemniﬁed Party will
            have the right, not to be exercised unreasonably, to reject any
            settlement or compromise that requires that it admit wrongdoing or
            liability or subjects one of them to any ongoing affirmative
            obligations.
          </p>
        </article>
        <article className={bem("content")}>
          <h5>13. Limited Liability.</h5>
          <p>
            <b>(a) Limitations of Pointment’s Liability. </b> POINTMENT’S
            LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT, OR SERVICES
            PROVIDED AS A RESULT OF THIS AGREEMENT, WILL NOT EXCEED THE FEES
            PAID FOR SERVICES PURCHASED ON THE WEBSITE AND/OR THE APP. IN NO
            EVENT WILL POINTMENT BE LIABLE FOR ANY CONSEQUENTIAL, INDIRECT,
            SPECIAL, INCIDENTAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED
            TO THIS AGREEMENT. THE LIABILITIES LIMITED BY THIS SECTION APPLY:
            (i) TO LIABILITY FOR NEGLIGENCE; (ii) REGARDLESS OF THE FORM OF
            ACTION, WHETHER IN CONTRACT, TORT, STRICT PRODUCT LIABILITY,
            INTELLECTUAL PROPERTY INFRINGEMENT, OR OTHERWISE; (iii) EVEN IF
            POINTMENT IS ADVISED IN ADVANCE OF THE POSSIBILITY OF THE DAMAGES IN
            QUESTION AND EVEN IF SUCH DAMAGES WERE FORESEEABLE; AND (iv) EVEN IF
            THE GUEST’S REMEDIES FAIL OF THEIR ESSENTIAL PURPOSE. If applicable
            law limits the application of the provisions of this Section,
            Pointment’s liability will be limited to the maximum extent
            permissible.
            <br />
            <br />
            <b>(b) Exceptions.</b> The limitations of liability in Section 13(a)
            do not apply to: (i) your obligation to pay fees for Service Packs
            or Subscriptions or (iii) claims pursuant to Section 12
            (Indemniﬁcations).
          </p>
        </article>
        <article className={bem("content")}>
          <h5>14. Miscellaneous.</h5>
          <p>
            <b>(a) Severability. </b> To the extent permitted by applicable law,
            you and Pointment hereby waive any provision of law that would
            render any clause of this Agreement invalid or otherwise
            unenforceable in any respect. In the event that a provision of this
            Agreement is held to be invalid or otherwise unenforceable, such
            provision will be interpreted to fulfill its intended purpose to the
            maximum extent permitted by applicable law, and the remaining
            provisions of this Agreement will continue in full force and effect.
            <br />
            <br />
            <b>(b) Assignment.</b> Pointment may transfer, sub-contract, or
            otherwise deal with Pointment’s rights and/or obligations under
            these Terms of Use without notifying you or obtaining your consent.
            An assignment authorized pursuant to the preceding sentence shall
            not become effective unless and until the assignee agrees in writing
            to be bound by all the assigning party’s rights and obligations set
            forth in these Terms and Conditions. You may not transfer,
            sub-contract, or otherwise deal with your rights and/or obligations
            under the Terms of Use.
            <br />
            <br />
            <b>(c) Entire Agreement.</b> This Agreement sets forth the entire
            agreement of the parties and supersedes all prior or contemporaneous
            writings, negotiations, and discussions with respect to its subject
            matter. Neither you nor Pointment has relied upon any such prior or
            contemporaneous communications.
            <br />
            <br />
            <b>(d) Amendment.</b> Pointment may amend this Agreement from time
            to time by posting an amended version on the Website and App and by
            sending you written notice thereof. Such amendment will become
            eﬀective thirty (30) days after such notice (unless you ﬁrst
            terminate your account pursuant to Section 9, Termination). Your
            continued use of the Appointment Service after such thirty (30) day
            notice period will confirm your consent to such amendment.
            <br />
            <br />
            <b>(e) Waiver.</b> Neither you nor Pointment will be deemed to have
            waived any of its rights under this Agreement by lapse of time or by
            any statement or representation other than by an authorized
            representative in an explicit written waiver. No waiver of a breach
            of this Agreement will constitute a waiver of any other breach of
            this Agreement.
            <br />
            <br />
            <b>(f) Force Majeure.</b> No delay, failure, or default, other than
            a failure to pay fees when due, will constitute a breach of this
            Agreement to the extent caused by acts of war, terrorism,
            hurricanes, earthquakes, pandemics, other acts of God or of nature,
            strikes or other labor disputes, riots or other acts of civil
            disorder, embargoes, or other causes beyond the performing party’s
            reasonable control.
            <br />
            <br />
            <b>(g) Governing Law.</b> This Agreement will be governed solely by
            the internal laws of the State of California, without reference to
            any conflicts of law principle that would apply the substantive laws
            of another jurisdiction to either your or Pointment’s rights or
            duties. You and Pointment consent to the personal and exclusive
            jurisdiction of the federal and state courts of San Francisco,
            California.
          </p>
        </article>
        REVISION DATE: July 2024
      </section>
      <TocPrivacyPolicyFooter />
    </div>
  );
};

export default TermsAndConditions;
